import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairRegisterModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "StaffGradFairRegisterModalContainer" */
      './StaffGradFairRegisterModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
